import React from 'react';

import { Box, Typography } from '~/components/utils';

import { Container } from './styles';

interface TabPanelProps {
  children: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <Container
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box p={3} height="100%">
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </Container>
  );
}

export default TabPanel;
